import styled from 'styled-components';
import * as glx from 'assets/css/glx';

const footerHeight = 134;

export const Login = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  box-sizing: border-box;
  padding-top: 22px;
  padding-bottom: ${footerHeight}px;
`;

export const BgImg = glx.BgImg;

export const Header = styled.div`
  margin: 0 30px;
  height: 152px;

  /* border: 1px solid rgba(3, 163, 146, 1); */
`;

export const Content = styled.div`
  margin-top: 80px;
  display: flex;
  justify-content: flex-end;
  width:1400px;
  margin-left:auto;
  margin-right:auto;
`;

export const Service = styled.div``;

export const LoginForm = styled.div`
  margin-left: 300px;
  margin-right:40px;
  width: 462px;
  height: 571px;
`;

export const Footer = styled.div`
  position: fixed;

  bottom: 0;
  width: 100%;
  height: ${footerHeight}px;
  background: rgba(0, 0, 0, 0.6);
`;
